'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function BlogCardSkeleton({
  inBlogList = false,
  index,
}: {
  inBlogList?: boolean;
  index: number;
}) {
  return (
    <div
      className={cn(
        'animate-pulse',
        'col-span-1 h-[477px] w-full rounded-[24px] bg-neutral-100 sm:h-[430px] lg:h-[348px]',
        inBlogList && index === 0 && 'sm:col-span-2 lg:h-[460px]',
      )}
    />
  );
}
